<template>
  <div class="home-container">
    <!-- 图表区域 -->
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="chart-card">
          <div slot="header" class="chart-header">
            <span><i class="el-icon-data-line"></i> 页面访问量统计 (PV)</span>
          </div>
          <div ref="pvChart" class="chart-box"></div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="chart-card">
          <div slot="header" class="chart-header">
            <span><i class="el-icon-user"></i> 独立访客统计 (UV)</span>
          </div>
          <div ref="uvChart" class="chart-box"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: "Home",
  data() {
    return {
      pvChart: null,
      uvChart: null,
      pvuvData: {
        today: [],
        yesterday: []
      }
    }
  },
  mounted() {
    this.initCharts()
    this.loadPvuvData()

    // 添加窗口大小改变时的自适应
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize)
    if (this.pvChart) {
      this.pvChart.dispose()
    }
    if (this.uvChart) {
      this.uvChart.dispose()
    }
  },
  methods: {
    handleResize() {
      this.pvChart && this.pvChart.resize()
      this.uvChart && this.uvChart.resize()
    },
    initCharts() {
      this.pvChart = echarts.init(this.$refs.pvChart)
      this.uvChart = echarts.init(this.$refs.uvChart)

      const commonOption = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          borderColor: '#eee',
          borderWidth: 1,
          textStyle: {
            color: '#666'
          },
          axisPointer: {
            type: 'none'
          },
          padding: [10, 15]
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '10%',
          top: '30%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            interval: 0,
            fontSize: 12,
            color: '#666',
            fontStyle: 'normal',
            margin: 15
          },
          axisLine: {
            lineStyle: {
              color: '#eee'
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          minInterval: 1,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#eee',
              type: 'dashed'
            }
          },
          axisLabel: {
            color: '#666'
          }
        }
      }

      // PV图表配置
      const pvOption = {
        ...commonOption,
        backgroundColor: '#fff',
        title: {
          text: '页面访问量(PV)',
          left: 'center',
          top: 10,
          textStyle: {
            color: '#333',
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        legend: {
          top: 45,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: '#666',
            fontSize: 13
          },
          itemGap: 30,
          bottom: 20,
          data: ['今日PV', '昨日PV']
        },
        series: [
          {
            name: '今日PV',
            type: 'bar',
            barWidth: '35%',
            itemStyle: {
              color: '#409EFF',
              borderRadius: [4, 4, 0, 0]
            },
            emphasis: {
              itemStyle: {
                color: '#66b1ff'
              }
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 12,
              fontWeight: 'bold',
              color: '#409EFF',
              formatter: '{c}'
            },
            data: []
          },
          {
            name: '昨日PV',
            type: 'bar',
            barWidth: '35%',
            itemStyle: {
              color: '#E6A23C',
              borderRadius: [4, 4, 0, 0]
            },
            emphasis: {
              itemStyle: {
                color: '#ebb563'
              }
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 12,
              fontWeight: 'bold',
              color: '#E6A23C',
              formatter: '{c}'
            },
            data: []
          }
        ]
      }

      // UV图表配置
      const uvOption = {
        ...commonOption,
        backgroundColor: '#fff',
        title: {
          text: '独立访客数(UV)',
          left: 'center',
          top: 10,
          textStyle: {
            color: '#333',
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        legend: {
          top: 45,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: '#666',
            fontSize: 13
          },
          itemGap: 30,
          bottom: 20,
          data: ['今日UV', '昨日UV']
        },
        series: [
          {
            name: '今日UV',
            type: 'bar',
            barWidth: '35%',
            itemStyle: {
              color: '#67C23A',
              borderRadius: [4, 4, 0, 0]
            },
            emphasis: {
              itemStyle: {
                color: '#85ce61'
              }
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 12,
              fontWeight: 'bold',
              color: '#67C23A',
              formatter: '{c}'
            },
            data: []
          },
          {
            name: '昨日UV',
            type: 'bar',
            barWidth: '35%',
            itemStyle: {
              color: '#F56C6C',
              borderRadius: [4, 4, 0, 0]
            },
            emphasis: {
              itemStyle: {
                color: '#f78989'
              }
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 12,
              fontWeight: 'bold',
              color: '#F56C6C',
              formatter: '{c}'
            },
            data: []
          }
        ]
      }

      this.pvChart.setOption(pvOption)
      this.uvChart.setOption(uvOption)
    },
    loadPvuvData() {
      this.request.get("/echarts/getPvUv").then(res => {
        if (res.code === '200') {
          const data = res.data
          this.pvuvData = data

          // 页面名称映射
          const pageNameMap = {
            'home': '关于我们',
            'custom': '程序定制',
            'highlights': '项目亮点',
            'guide': '防骗指南',
            'annualReports': '历年报表',
            'diagram': 'ER图/三线表',
            'structureChart': '功能图',
            'useCaseDiagram': '用例图',
            'flowchart': '流程图',
            'swimlane': '泳道图',
            'sequence': '时序图',
            'taskBook': '任务书',
            'articleGenerate': '文章生成',
            'testCase': '测试用例',
            'aigcCheck': 'AIGC检测',
            'reduceAigc': '降重降AIGC'
          }

          // 获取所有不同的页面名称
          const pageNames = new Set([
            ...data.today.map(item => item.pageName),
            ...data.yesterday.map(item => item.pageName)
          ])

          // 初始化数据数组
          const todayPVData = []
          const yesterdayPVData = []
          const todayUVData = []
          const yesterdayUVData = []
          const chinesePageNames = []

          // 处理每个页面的数据
          pageNames.forEach(pageName => {
            const todayData = data.today.find(item => item.pageName === pageName) || { pv: 0, uv: 0 }
            const yesterdayData = data.yesterday.find(item => item.pageName === pageName) || { pv: 0, uv: 0 }

            todayPVData.push(todayData.pv)
            yesterdayPVData.push(yesterdayData.pv)
            todayUVData.push(todayData.uv)
            yesterdayUVData.push(yesterdayData.uv)
            chinesePageNames.push(pageNameMap[pageName] || pageName)
          })

          // 更新PV图表数据
          this.pvChart.setOption({
            xAxis: {
              data: chinesePageNames
            },
            series: [
              {
                name: '今日PV',
                data: todayPVData
              },
              {
                name: '昨日PV',
                data: yesterdayPVData
              }
            ]
          })

          // 更新UV图表数据
          this.uvChart.setOption({
            xAxis: {
              data: chinesePageNames
            },
            series: [
              {
                name: '今日UV',
                data: todayUVData
              },
              {
                name: '昨日UV',
                data: yesterdayUVData
              }
            ]
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.home-container {
  min-height: calc(100vh - 60px);
}

/* 图表卡片 */
.chart-card {
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
  overflow: hidden;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
}

.chart-header span {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
}

.chart-header i {
  font-size: 20px;
  color: #409EFF;
}

.chart-box {
  height: 400px;
  padding: 20px;
  position: relative;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .chart-box {
    height: 300px;
    padding: 10px;
  }

  .chart-header span {
    font-size: 16px;
  }
}
</style>
